var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.623 0 24 5.37703 24 12C24 18.623 18.623 24 12 24C5.37703 24 0 18.623 0 12C0 5.37703 5.37703 0 12 0ZM9.88636 18.3824C15.1965 18.3824 18.1 13.9823 18.1 10.1688C18.1 10.0431 18.1 9.91739 18.094 9.79763C18.6567 9.39056 19.1476 8.88169 19.5368 8.301C19.0219 8.52848 18.4651 8.68416 17.8785 8.75597C18.4771 8.39677 18.9321 7.83403 19.1476 7.15758C18.5909 7.48683 17.9743 7.72627 17.3157 7.85798C16.7889 7.29525 16.0406 6.94805 15.2085 6.94805C13.616 6.94805 12.3229 8.24114 12.3229 9.83358C12.3229 10.0611 12.3469 10.2825 12.4007 10.4921C10.0001 10.3724 7.87486 9.22294 6.45009 7.47483C6.20461 7.89989 6.06094 8.39677 6.06094 8.92359C6.06094 9.92334 6.56981 10.8094 7.34808 11.3242C6.87511 11.3122 6.43209 11.1805 6.04298 10.965V11.001C6.04298 12.4018 7.03673 13.5632 8.35978 13.8326C8.12034 13.8984 7.86291 13.9344 7.59952 13.9344C7.41389 13.9344 7.23431 13.9164 7.05473 13.8805C7.41989 15.0299 8.4855 15.8621 9.74869 15.886C8.76089 16.6583 7.5157 17.1193 6.1627 17.1193C5.92922 17.1193 5.70173 17.1073 5.47425 17.0774C6.73744 17.9035 8.25802 18.3824 9.88636 18.3824Z",
    fill: "#393E42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e5b6d6cb.svg";
export { ForwardRef as ReactComponent };